import * as React from "react";

const StarIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    fill="none"
    viewBox="0 0 17 16"
  >
    <g clipPath="url(#clip0_1134_368)">
      <path
        stroke="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m8.38.616 2.4 4.86 5.365.784-3.883 3.783.91 5.346-4.8-2.523-4.79 2.523.915-5.342L.615 6.26l5.366-.784z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_1134_368">
        <path fill="#fff" d="M0 0h16.761v16H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default StarIcon;
